export default __webpack_public_path__ + "static/media/applestore.5f962986.png";